import { useCallback } from 'react'

import { useProjectContext, useProjectDispatch } from 'services/Store/Project/hooks'
import { getTestEndTrigger } from 'services/Store/Project/triggers'
import { focusMain } from 'utils/accessibility'

import BaseButtonElement from '../BaseButtonElement'
import type { ButtonElementType } from '../buttonTypes'
import { getButtonLabel } from '../helper'

interface IDefaultButtonElementProps extends React.ComponentProps<ButtonElementType> {
  children: React.ReactNode
}

const EndButtonElement: React.FC<IDefaultButtonElementProps> = ({
  element,
  mode,
  styles,
  font,
  children,
}) => {
  const dispatch = useProjectDispatch()
  const trigger = useProjectContext(getTestEndTrigger)

  const label = getButtonLabel(
    {
      'project/testEnd': element.value.label,
      'project/setCourseNavigation': element.value.secondLabel,
      'project/courseEnd': element.value.thirdLabel,
      noop: element.value.label,
    },
    trigger.action,
  )

  const onClick = useCallback(() => {
    if (!trigger.disabled) {
      dispatch(trigger.actionCreator())
      focusMain()
    }
  }, [dispatch, trigger])

  return (
    <BaseButtonElement
      action={element.value.action}
      disabled={trigger.disabled}
      elementId={element.id}
      font={font}
      label={label}
      mode={mode}
      onClick={onClick}
      styles={styles}
    >
      {children}
    </BaseButtonElement>
  )
}

export default EndButtonElement
